import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { RoleState } from '@role/store/role.reducer';
import * as RoleActions from '@role/store/role.actions';
import * as roleSelectors from '@role/store/role.selectors';
import { Role } from '@models';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.sass']
})

export class RoleListComponent implements OnInit {
  private roleState: Observable<RoleState>;
  roles: Observable<Role[]>;
  isPending: Observable<boolean>;

  constructor(
    private store: Store<{roles: RoleState}>,
  ) {
    this.store.dispatch(RoleActions.GetList());
    this.roles = this.store.select(roleSelectors.getCollection);
    // this.roleState = store.pipe(select('roles'));
    // this.roles = this.roleState.pipe(map((responseBody: RoleState) => responseBody.data));
    // this.isPending = this.roleState.pipe(map((responseBody: RoleState) => responseBody.pending));
  }

  ngOnInit() { }

}
